<!-- new theme implementation starts -->
<div class="subheader with-padding flgrow">
    <div class="row">
        <div class="col-lg-3 col-md-6 col-sm-8">
            <div class="relative flmid">
                <div class="input-group flgrow">
                    <input class="form-control" type="text" name="searchTerm" placeholder="{{ 'lblSearch' | translate }}" [(ngModel)]="searchTerm" autocomplete="off" (keyup.enter)="onSearchFilter()" />
                    <div class="input-group-append">
                        <button type="button" class="btn btn-primary" (click)="onSearchFilter()">
                                <em class="fa fa-search"></em>
                            </button>
                    </div>
                </div>
            </div>
        </div>
        <div class='col-lg-3 col-md-3 col-sm-8 pl-4'>
            <ng-select placeholder="{{ 'lblDMSName' | translate }}" [(ngModel)]="selectedDMSName" (change)="DMSNameChange($event)">

                <ng-option *ngFor="let dmsName of dmsNameList" [value]="dmsName.id">
                    {{dmsName.name}}
                </ng-option>
            </ng-select>
        </div>

        <div class='col-lg-3 col-md-3 col-sm-8'>
            <ng-select placeholder="{{ 'lblTableName' | translate }}" [(ngModel)]="selectedTableName" (change)="TableNameChange($event)">

                <ng-option *ngFor="let tableName of tableNames" [value]="tableName.id">
                    {{tableName.name}}
                </ng-option>
            </ng-select>
        </div>
        <div class="col-auto">
            <button type="button" (click)="Search()" type="reset" class="add-button btn btn-primary" aria-label="Center Align" translate>View</button>
        </div>
    </div>
</div>
<div class="container prel">
    <div class="row">
        <div class="c12">
            <div class="card mb-3">
                <div class="card-header d-flex justify-content-between">
                    <h4 class="card-title" translate>lblDMSDefaultValues</h4>
                    <div class="font16 fontbold">
                        <span class="font16 fontnormal" translate>lblTotal</span>:&nbsp;{{ totalCount }}&nbsp;
                        <span class="font16 fontnormal" translate>lblResults</span>
                    </div>
                </div>
                <div class="table-responsive max-h232" infinite-scroll [infiniteScrollDistance]="scrollDistance" [infiniteScrollThrottle]="throttle" [scrollWindow]="false" (scrolled)="onScrollDown($event)">
                    <table class="tablest1">
                        <thead>
                            <tr>
                                <th style="width: 55px" scope="col">#</th>
                                <th style="width: 15%" scope="col" sortable="dmsName" (sort)="onSort($event)" translate>lblDMSName</th>
                                <th scope="col" sortable="tableName" (sort)="onSort($event)" translate>lblTableName
                                </th>
                                <th style="width: 15%" scope="col" sortable="dmsColumnName" (sort)="onSort($event)" translate>lblDMSColumnName</th>
                                <th style="width: 15%" scope="col" sortable="dmsValues" (sort)="onSort($event)" translate>lblDMSValues</th>
                                <th style="width: 15%" scope="col" sortable="dmsColumnDataType" (sort)="onSort($event)" translate>lblDMSColumnDataType</th>
                                <th style="width: 120px" scope="col" class="text-center" translate>lblAction</th>
                            </tr>
                        </thead>
                        <tbody>
                            <ng-container *ngIf="DMSDefaultList?.length>0; else load_else">
                                <tr *ngFor="let dmsvalue of DMSDefaultList; let i=index">
                                    <td>{{ dmsvalue.RowId }}</td>
                                    <td>
                                        <ngb-highlight [result]="dmsvalue.DMSName"></ngb-highlight>
                                    </td>
                                    <td>
                                        <ngb-highlight [result]="dmsvalue.TableName"></ngb-highlight>

                                    </td>
                                    <td>
                                        <ngb-highlight [result]="dmsvalue.DMSColumnName"></ngb-highlight>

                                    </td>
                                    <td>
                                        <ngb-highlight *ngIf="!(enableEdit && enableEditIndex == i)" [result]="dmsvalue.DMSValues"></ngb-highlight>
                                        <input class="form-control" type="text" *ngIf="enableEdit && enableEditIndex == i" [(ngModel)]="dmsvalue.DMSValues">
                                    </td>
                                    <td>
                                        <ngb-highlight [result]="dmsvalue.DMSColumnDataType"></ngb-highlight>

                                    </td>
                                    <td class="nowrap text-center">
                                        <a class="btn btn-ico" ngbTooltip="{{'lblEdit' | translate}}" tooltipClass="custom-revert" (click)="enableEditMethod($event, i)" *ngIf="userRoleRightsDetails.canEdit && !(enableEdit && enableEditIndex == i)">
                                            <em class="fas fa-pencil-alt fa-lg"></em>
                                        </a>
                                        <a class="btn btn-ico" ngbTooltip="{{'lblSave' | translate}}" tooltipClass="custom-revert" (click)="saveSegment(dmsvalue, i)" *ngIf="enableEdit && enableEditIndex == i">
                                            <i class="fa fa-save fa-lg" aria-hidden="true"></i>
                                        </a>
                                        <span class="ico-div" *ngIf="enableEdit && enableEditIndex == i"></span>
                                        <a class="btn btn-ico" ngbTooltip="{{'lblCancel' | translate}}" tooltipClass="custom-revert" (click)="cancel()" *ngIf="enableEdit && enableEditIndex == i">
                                            <em class="fas fa-times fa-lg text-danger"></em>
                                        </a>
                                    </td>
                                </tr>
                            </ng-container>
                            <ng-template #load_else>
                                <tr>
                                    <td colspan="8" class="no-record" translate>lblNoRecordsFound</td>
                                </tr>
                            </ng-template>
                        </tbody>
                    </table>
                </div>
            </div>

        </div>
    </div>

</div>
<!-- new theme implementation ends -->